//
import fetchAll from './fetchAll'

//
export default {
    fetchAll
}